module.exports = __webpack_public_path__ + "static/media/programa-370-virgen-coromoto.098972c4.jpg";